<template>
  <div class="container" :style="{
      backgroundImage: 'url( ' + bottomPic + ')',
      backgroundSize: 'cover',
      backgroundRepleat: 'no-repeat',
      backgroundPosition:'center center'
    }">
    <component
      :is="view"
      :paramsObj="params"
      :activityId="activityId"
      :outreachChannelCode="outreachChannelCode"
      :allData="allData"
      v-if="promotionStatus == 2 || promotionStatus == 5"
      @setLoginFun="getLoginFun"
    ></component>
    <end-active :promotiontype="promotionStatus"
                v-if="promotionStatus == 1||(cityCode&&promotionStatus != 2)||promotionStatus == 3||promotionStatus == 4 ||(cityCode&&promotionStatus == 5)"></end-active>
    <!--登录弹出层-->
    <select-login :loginShow="loginShow"></select-login>
  </div>
</template>
<script>
  import mobileType from '../../../utils/mobileType';
  import { getActivityInfo } from '@/apis/activity/common';
  import ownerCertification1 from '@/views/activity/ownerCertification/ownerCertification1';
  import ownerCertification from '@/views/activity/ownerCertification/ownerCertification1';
  import outOfRecruit from '@/views/activity/ownerCertification/ownerCertification1';
  import util from '@/utils/util';
  import EndActive from '../common/endActive';
  import SelectLogin from '../../../components/common/selectLogin';

  export default {
    components: {
      SelectLogin,
      EndActive,
      ownerCertification1,
      ownerCertification,
      outOfRecruit
    },
    data() {
      return {
        delog: false,
        type: 2, //1登录没有城市  3登录了有城市   4未登录没有城市
        promotionStatus: 2, //活动信息 活动状态 1 待开始 2 活动中 3 已下架 4 已结束 5 不满足城市要求 6 不满足活动人群要求
        templateType: null,
        templateArr: ['ownerCertification1', 'ownerCertification', 'outOfRecruit'],
        view: '',
        toast: '您已经是代驾司机啦，快去邀请好友获得奖励吧～',
        params: {
          areaCode: '',
          channel: '10600003',
          deviceId: util.getUUID(),
          platform: null,
          softVersion: '7.0.4',
          sysVersion: 'iOS 10.0.1',
          token: '',
        },
        activityId: null,
        cityCode: null,
        source: null,
        outreachChannelCode: null,
        driverId: null,
        iconPic: null,
        loginShow: false,//登录选择
        allData: {},//基础信息
        bottomPic: '',
      };
    },
    watch: {
      params(newVal) {
        this.params = newVal;
        this.view = this.templateArr[this.templateType];
        // console.log(this.params);
      },
    },
    created() {
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      let userInfoDjsj = this.$storage.get('userInfoDjsj') || {};
      // if (userInfoDjsj) {
      this.cityCode = userInfoDjsj.cityCode;
      userInfoDjsj.activityId = this.$route.query.activityId;
      this.driverId = userInfoDjsj.driverId;
      if (this.$route.query.outreachChannelCode) {
        userInfoDjsj.outreachChannelCode = this.$route.query.outreachChannelCode;
      }
      this.$storage.setSession('userInfoDjsj', userInfoDjsj);
      // }
      if (this.$route.query.activityId) {
        this.activityId = this.$route.query.activityId;
      }
      if (this.$route.query.source) {
        this.source = +this.$route.query.source;
      }
      if (this.$route.query.data) {
        let params = decodeURIComponent(this.$route.query.data);
        this.params = Object.assign({}, this.params, JSON.parse(params));
        let areaCode = this.params.areaCode;
        let cityCode = +(areaCode.slice(0, 4) + '00');
        this.cityCode = cityCode;

        let userInfoDjsj = this.$storage.get('userInfoDjsj') || {};
        userInfoDjsj.cityCode = cityCode;
        userInfoDjsj.platform = +this.params.platform;
        this.$storage.setSession('userInfoDjsj', userInfoDjsj);

        this.queryActivityFun();
      } else if (this.$route.query.platform == 4) {
        this.params.platform = 4;
        this.activityId = this.$route.query.activityId;
        this.outreachChannelCode = this.$route.query.outreachChannelCode;
        this.queryActivityFun();
      } else {
        this.$apiFun.getUserInfoFromApp();
      }
    },
    methods: {
      //APP交互后获取params
      getDataFromNative(params) {
        this.params = this.$apiFun.getParams(params);
        console.log('1,2+this.params=', this.params);
        console.log('1,2+this.$route.query=', this.$route.query);
        let areaCode = this.params.areaCode;
        let cityCode = +(areaCode.slice(0, 4) + '00');
        this.cityCode = cityCode;

        let userInfoDjsj = this.$storage.get('userInfoDjsj') || {};
        userInfoDjsj.cityCode = cityCode;
        this.$storage.setSession('userInfoDjsj', userInfoDjsj);

        if (this.$route.query.activityId) {
          this.activityId = this.$route.query.activityId;
        }
        this.outreachChannelCode = this.params.outreachChannelCode;
        this.queryActivityFun();
      },
      //埋点
      getinfoCode() {
        // if (this.activityId) {
        //   if (this.outreachChannelCode) {
        //     //埋点
        //     sensors.track('MarketActivityCarAuth', {
        //       activity_id: this.activityId,
        //       outreach_channel_code: this.outreachChannelCode,
        //     });
        //   } else {
        //     //埋点
        //     sensors.track('MarketActivityCarAuth', {
        //       activity_id: this.activityId,
        //     });
        //   }
        // }
      },
      //获取活动信息
      async queryActivityFun() {
        let params = { ...this.params };
        let shareParam = {};
        if (this.$route.query.shareParam) {
          shareParam = JSON.parse(decodeURIComponent(this.$route.query.shareParam));
        }
        params.data = util.filterParams({
          activityId: this.activityId,
          distributionCode: this.outreachChannelCode,
          cityCode: this.cityCode ? this.cityCode : null,
          realChannelId: shareParam.realChannelId,
        });
        params.token = '';
        params.data = JSON.stringify(params.data);
        try {
          const data = await getActivityInfo(params);
          if (data.code == 1) {
            let datas = JSON.parse(data.data);
            this.allData = datas;
            let promotionStatus = JSON.parse(data.data).promotionStatus;
            // 活动状态 1 待开始 2 活动中 3 已下架 4 已结束 5 不满足城市要求 6 不满足活动人群要求
            this.promotionStatus = promotionStatus;
            if (datas.activitySpreadVo) {
              this.bottomPic = datas.activitySpreadVo.skinBottomImg;
            }
            document.getElementsByTagName('title')[0].innerText = JSON.parse(
              data.data
            ).name;
            this.$route.meta.title = JSON.parse(data.data).name;
            this.templateType = JSON.parse(data.data).templateType;
            this.view = this.templateArr[this.templateType];
          }
        } catch (error) {
        }
      },
      getLoginFun() {
        this.loginShow = true;
      },
    },
  };
</script>
<style lang="less" scoped>
  .activity-bg {
    background: #DF3222;
    position: relative;
  }
</style>


